import config from "../../config";

export function getAlertCategoryLabel(type, translate, translationExists) {
  const labelKey = `alert_category_${type}`;

  if (translationExists(labelKey)) {
    return translate(labelKey);
  }

  const category = config.alertCategories.find(({ key }) => key === type);

  return category ? translate(category.name) : type;
}

export function getNotificationCategoryLabels(
  notificationTypes,
  translate,
  translationExists
) {
  return notificationTypes.map(type =>
    getAlertCategoryLabel(type, translate, translationExists)
  );
}

export function formatNotificationCategoryLabels(labels, locale) {
  if (labels.length <= 1) {
    return labels.join("");
  }

  if (typeof Intl !== "undefined" && Intl.ListFormat) {
    return new Intl.ListFormat(locale, {
      style: "long",
      type: "conjunction"
    }).format(labels);
  }

  return labels.join(", ");
}
